import { render, staticRenderFns } from "./MedicoesInventario.vue?vue&type=template&id=173d882c&scoped=true"
import script from "./MedicoesInventario.vue?vue&type=script&lang=js"
export * from "./MedicoesInventario.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=173d882c&prod&scoped=true&lang=css&external"
import style1 from "./MedicoesInventario.vue?vue&type=style&index=1&id=173d882c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d882c",
  null
  
)

export default component.exports